import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '@/core/hooks/usePermissions';

const ReportRedirect = () => {
  const navigate = useNavigate();
  const { hasPermission, permissions, permissionsLoading } = usePermissions();

  useEffect(() => {
    // Check permissions for each report type and redirect to the first one available
    if (hasPermission('user_report_read') && permissions.length > 0 && !permissionsLoading) {
      navigate('user-reports', { replace: true });
    } else if (
      hasPermission('company_report_read') &&
      permissions.length > 0 &&
      !permissionsLoading
    ) {
      navigate('companyReports', { replace: true });
    } else if (
      hasPermission('portal_report_read') &&
      permissions.length > 0 &&
      !permissionsLoading
    ) {
      navigate('portal-reports', { replace: true });
    } else {
      // If user has no permissions for any reports, redirect to dashboard
      navigate('/reports', { replace: true });
    }
  }, [hasPermission, navigate, permissions, permissionsLoading]);

  return null;
};

export default ReportRedirect;
